module.exports = __webpack_public_path__ + "img/d11b85c983a95f7f6696972ae9e3f1d.b81642f4.jpg";